import axios from "axios";
import authService from "@/core/services/AuthService";
import emitter from "@/boot/eventBus";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Access-Control-Allow-Origin": "*",
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = authService.getToken();

        if (token) {
            config.headers["authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 500) {
            emitter.emit("show-error-toast", {
                message: "An unknown error occurred while processing your request.",
            });

            return;
        }

        if (error.response?.status === 400) {
            const message = error.response?.data.message ?? "Unknow error";
            emitter.emit("show-error-toast", {
                message,
            });

            return;
        }

        if (error.response?.status === 401) {
            emitter.emit("show-error-toast", {
                message: "Access to resource denied",
            });

            return;
        }

        return Promise.reject(error); // allow other errors to propagate
    },
);

export default axiosInstance;
